<template>
    <div class="emotional-status-container">
        <van-nav-bar title="情感状态" left-arrow :border="false" @click-left="onClickLeft" />
        <div class="status-content">
            <div class="status-tip">请选择您的当前情感状态</div>
            <van-cell-group>
                <van-cell v-for="item in statusList" :key="item.value" clickable
                    :class="{ 'selected': selectedStatus === item.value }" @click="onSelectStatus(item.value)">
                    <template #title>
                        <span class="status-label">{{ item.label }}</span>
                    </template>
                </van-cell>
            </van-cell-group>
        </div>
        <div class="status-footer">
            <van-button type="primary" block round :loading="loading" @click="handleSave">
                保存
            </van-button>
        </div>
    </div>
</template>

<script>
import { Toast } from 'vant';
import { updateUserInfo } from '@/api/user';
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            selectedStatus: null,
            loading: false,
            statusList: [
                { value: 1, label: '单身ing' },
                // { value: 2, label: '暗恋中' },
                // { value: 3, label: '暧昧中' },
                { value: 4, label: '恋爱ing' },
                // { value: 5, label: '订婚' },
                { value: 6, label: '已结婚' },
                // { value: 99, label: '其他' }
            ]
        };
    },
    computed: {
        ...mapGetters(['baseInfo'])
    },
    methods: {
        onClickLeft() {
            this.$router.go(-1);
        },
        onSelectStatus(value) {
            this.selectedStatus = value;
        },
        async handleSave() {
            this.loading = true;
            try {
                const data = {
                    ...this.baseInfo,
                    emotionalStatus: this.selectedStatus
                };
                const res = await updateUserInfo(data);
                if (res.code === 20000) {
                    this.$store.dispatch('UpdateBasicInfo', res.data);
                    Toast.success('保存成功');
                    this.$router.go(-1);
                } else {
                    Toast.fail(res.message || '保存失败');
                }
            } catch (error) {
                Toast.fail('保存失败');
                console.error('保存情感状态失败', error);
            } finally {
                this.loading = false;
            }
        }
    },
    created() {
        this.selectedStatus = this.baseInfo.emotionalStatus || null;
    }
};
</script>

<style lang="less" src="../style/emotionalStatusEdit.less" />



// WEBPACK FOOTER //
// src/views/emotionalStatusEdit.vue